var mapStyles = [
	{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [
		  {
			"color": "#525f6b"
		  },
		  {
			"gamma": "1"
		  },
		  {
			"weight": "1"
		  },
		  {
			"lightness": "0"
		  },
		  {
			"saturation": "0"
		  }
		]
	},
	{
		"featureType": "administrative",
		"elementType": "labels.text.stroke",
		"stylers": [
		  {
			"weight": "1.5"
		  },
		  {
			"color": "#ffffff"
		  },
		  {
			"saturation": "0"
		  },
		  {
			"lightness": "0"
		  }
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry.stroke",
		"stylers": [
		  {
			"visibility": "off"
		  },
		  {
			"color": "#7d8790"
		  }
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "all",
		"stylers": [
		  {
			"visibility": "on"
		  }
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "all",
		"stylers": [
		  {
			"visibility": "on"
		  }
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "geometry.stroke",
		"stylers": [
		  {
			"visibility": "on"
		  }
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [
		  {
			"color": "#efeff0"
		  },
		  {
			"lightness": "35"
		  }
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
		  {
			"visibility": "off"
		  }
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
		  {
			"saturation": "-100"
		  },
		  {
			"lightness": 45
		  }
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [
		  {
			"visibility": "simplified"
		  },
		  {
			"saturation": "-100"
		  }
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels",
		"stylers": [
		  {
			"visibility": "off"
		  }
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [
		  {
			"visibility": "off"
		  }
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
		  {
			"visibility": "off"
		  }
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
		  {
			"color": "#7FC6E7"
		  },
		  {
			"visibility": "on"
		  }
		]
	}
];

window.mapStyles = mapStyles;
